import { render, staticRenderFns } from "./CreateOrUpdateRegistration.vue?vue&type=template&id=4b0a8c7c&"
import script from "./CreateOrUpdateRegistration.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports